import { rpx } from 'client/lib/rpx-client';
import { defCoursesRoute } from '@course/components/courses-app-router';
import { LoadedProps, RouteLoadProps } from '@components/router';
import { ReadonlyMinidoc } from '@components/minidoc/readonly-minidoc';

async function load(route: RouteLoadProps) {
  return rpx.customPages.getPublicPage({ slug: route.params.slug });
}

type Props = LoadedProps<typeof load>;

export const route = defCoursesRoute({
  isPublic: true,
  load,
  Page,
});

function Page(props: Props) {
  const { title, body } = props.state;

  return (
    <div class="min-h-screen bg-white">
      <div class="max-w-3xl mx-auto px-4 py-12">
        <h1 class="text-3xl font-bold mb-8">{title}</h1>
        {body && (
          <div class="prose max-w-none">
            <ReadonlyMinidoc content={body} />
          </div>
        )}
      </div>
    </div>
  );
}
